import {
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
    Menu,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"
import CollectionsIcon from "@material-ui/icons/Collections"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import HistoryIcon from "@material-ui/icons/History"
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile"
import SearchIcon from "@material-ui/icons/Search"
import SwapVertIcon from "@material-ui/icons/SwapVert"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useHistory, Prompt, Link } from "react-router-dom"
import logo99 from "../../../assets/99-app-logo-0.png"
import ifoodLogo from "../../../assets/ifood-logo.png"
import { alertStart } from "../../../routes"
import { SalvarCardapio99Food } from "../../../services/99food"
import {
    importarCardapioIfoodParaDigital,
    publicarCardapioDigitalNoIfood,
} from "../../../services/ifoodGerenciamento"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCardapioContext } from "./CardapioContext"
import { categoriaCasaBusca } from "../utils/buscaCardapio"
import Categorias from "./Categorias"
import DialogCategorias from "./DialogCategorias"
import FloatingIAButton from "./FloatingIAButton"
import DialogDuplicarGrupoDeOpcao from "./DialogDuplicarGrupoDeOpcao"
import DialogPassoDeMontagem from "./DialogPassoDeMontagem"
import DialogProdutos from "./DialogProdutos"
import DialogReordenar from "./DialogReordenar"

// Rótulos dos tipos de categoria (valor do enum -> texto exibido). Usado tanto
// para gerar os itens do filtro quanto para o renderValue da multisseleção.
const TIPOS_CATEGORIA = {
    DELIVERY: "Delivery",
    PEDIDO_MESA: "Mesa",
    REGISTRADOR: "Registrador",
}

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
    },
    cabecalho: {
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "& fieldset": { borderColor: "#e0e0e0" },
            "&:hover fieldset": { borderColor: "#4caf50" },
            "&.Mui-focused fieldset": { borderColor: "#4caf50" },
        },
        "& .container-opcoes-categorias": {
            display: "flex",
            flex: "1 1 100%",
            gap: "0.5rem",
            flexWrap: "wrap",
            [theme.breakpoints.up("md")]: {
                flex: "1 1 26rem",
            },
            "&>*": {
                flex: "1 1 auto",
                minWidth: "140px",
                [theme.breakpoints.down("sm")]: {
                    flex: "1 1 100%",
                },
            },
            // Busca é a ação em destaque: cresce mais que o filtro de tipo.
            "& .campo-busca": {
                flex: "2 1 11rem",
            },
        },
        zIndex: 9,
        width: "100vw",
        backgroundColor: "white",
        padding: "0.8rem",
        borderBottom: "solid 1px rgba(0,0,0, 0.4)",
        [theme.breakpoints.up("md")]: {
            position: "fixed",
            top: "calc(64px + var(--banner-height, 0px))",
            left: "var(--drawer-width, 80px)",
            width: "calc(100vw - var(--drawer-width, 80px))",
            paddingRight: "1.2rem",
            transition: "left 0.2s ease, width 0.2s ease",
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: "55px",
        },
    },
    botaoSalvar: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        backgroundColor: "#4caf50",
        color: "white",
        boxShadow: "0 4px 15px rgba(76,175,80,0.3)",
        "&:hover": {
            backgroundColor: "#45a049",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(76,175,80,0.4)",
        },
    },
    // Cadastrar Categoria fica visível na barra (ação de criação), destacado com
    // contorno verde + ícone "+" — sem competir com o preenchido do Salvar.
    botaoCadastrar: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        color: "#2e7d32",
        border: "2px solid #4caf50",
        backgroundColor: "#eafaf0",
        "&:hover": {
            backgroundColor: "#d7f3e1",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 15px rgba(76,175,80,0.25)",
        },
    },
    containerItens: {
        flexGrow: 1,
        [theme.breakpoints.up("md")]: {
            marginTop: "3.2rem",
        },
    },
    listItem: {
        paddingLeft: "0",
        paddingRight: "0",
    },
    botaoImprimir: {
        borderRadius: 25,
        textTransform: "none",
        fontWeight: 600,
        padding: "8px 22px",
        transition: "all 0.2s ease",
        color: "#4caf50",
        border: "1.5px solid #4caf50",
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "rgba(76,175,80,0.08)",
            transform: "translateY(-2px)",
        },
    },
    // Balão "em breve" ao lado do Sincronizar iFood (recurso ainda em liberação).
    chipEmBreve: {
        marginLeft: theme.spacing(1),
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        backgroundColor: "#fff3e0",
        color: "#e65100",
    },
    // Item de menu "em breve" sem ação (perfis que ainda não têm acesso): mantém
    // visível, mas sem cursor/hover de clique.
    itemSemAcao: {
        cursor: "default",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
}))

export default function NovaTelaProdutos() {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const classes = useStyles()
    const history = useHistory()

    const setLoading = useLoadingStore(s => s.setLoading)
    const loading = useLoadingStore(s => s.loading)
    const perfil = useAppStore(s => s.configuracoes?.user?.perfil)
    const ehClienteFiel = perfil === "CLIENTEFIEL"

    const {
        estabelecimento,
        cardapio,
        categorias,
        setCategorias,
        insumos,
        cadastrar,
        setCadastrar,
        setSalvarCardapioCompleto,

        categoriaAtual,
        setCategoriaAtual,
        produtoAtual,
        setProdutoAtual,
        openCategoria,
        setOpenCategoria,
        openProduto,
        setOpenproduto,
        openPassoDeMontagem,
        setOpenPassoDeMontagem,
        modalCategoria,
        setModalCategoria,
        modalProduto,
        setModalProduto,
        modalPasso,
        setModalPasso,
        idPasso,
        openDuplicarGrupoDeMontagem,
        handleToggleDuplicarGrupoDeMontagem,

        insumoSelecionado,
        setInsumoSelecionado,
        insumosSelecionados,
        fichaTecnica,
        quantidades,
        setQuantidades,
        setAltInsumo,
        produto,

        handleSalvarCategoria,
        persistirCategorias,
        handleDuplicarCategoria,
        handleExcluirCategoria,
        handleSalvarProduto,
        handleDuplicarProduto,
        handleExcluirProduto,
        handleCadastrarGrupoDeOpcao,
        handleDuplicarPassoDeMontagem,
        handleExcluirGrupoDeOpcao,
        handleCadastrarOpcao,
        handleExcluirOpcao,
        handleIdsEditar,
        handleSalvarCardapioInteiro,
        temAlteracoesPendentes,
        handleCadastrarImagem,
        handleAddInsumo,
        handleDeleteInsumo,
        salvarFt,
        buscarFT,
        renderKey,
        recarregarCardapio,
    } = useCardapioContext()

    const [valorPesquisa, setValorPesquisa] = useState("")
    const [tiposCategoria, setTiposCategoria] = useState([])
    const [draggingItem, setDraggingItem] = useState(null)
    const [openReordenar, setOpenReordenar] = useState(false)
    const [openConfirmacaoSalvar99, setOpenConfirmacaoSalvar99] = useState(false)
    const [anchorMenuAcoes, setAnchorMenuAcoes] = useState(null)
    // Diálogo de sincronização com o iFood. direcaoIfood: null (escolhendo),
    // "IMPORTAR" (iFood -> cardápio digital) ou "PUBLICAR" (cardápio digital -> iFood).
    const [openSincronizarIfood, setOpenSincronizarIfood] = useState(false)
    const [direcaoIfood, setDirecaoIfood] = useState(null)
    // Quando uma chamada ao iFood falha, guardamos a mensagem aqui para exibir no
    // próprio diálogo, junto de um link para revisar a integração.
    const [erroIfood, setErroIfood] = useState(null)
    const handleCloseConfirmacaoSalvar99 = () => setOpenConfirmacaoSalvar99(false)
    const handleAbrirMenuAcoes = e => setAnchorMenuAcoes(e.currentTarget)
    const handleFecharMenuAcoes = () => setAnchorMenuAcoes(null)
    const handleAbrirSincronizarIfood = () => {
        setDirecaoIfood(null)
        setErroIfood(null)
        setOpenSincronizarIfood(true)
    }
    const handleFecharSincronizarIfood = () => {
        if (loading) return
        setOpenSincronizarIfood(false)
        setDirecaoIfood(null)
        setErroIfood(null)
    }
    const handleRevisarIntegracaoIfood = () => {
        setOpenSincronizarIfood(false)
        setErroIfood(null)
        history.push("/servicos/modulo/integracao-ifood")
    }

    const salvarCardapio99 = async () => {
        setLoading(true)
        try {
            await SalvarCardapio99Food(cardapio)
            alertStart("Enviado para atualização!", "success")
            handleCloseConfirmacaoSalvar99()
        } catch (error) {
            console.error("Erro Salvar99", error.response)
            alertStart(error.response?.data, "error")
        } finally {
            setLoading(false)
        }
    }

    // Executa a sincronização escolhida com o iFood. O backup do cardápio que será
    // sobrescrito é responsabilidade do backend (feito antes de sobrescrever) —
    // ver docs/backend/sincronizacao-cardapio-ifood.md.
    const confirmarSincronizacaoIfood = async () => {
        if (!direcaoIfood) return
        const autorizacao = localStorage.getItem("chaveSistema")
        setLoading(true)
        setErroIfood(null)
        try {
            const resposta =
                direcaoIfood === "IMPORTAR"
                    ? await importarCardapioIfoodParaDigital(autorizacao)
                    : await publicarCardapioDigitalNoIfood(autorizacao)
            if (resposta?.retornoErro) {
                // Mostra o erro no próprio diálogo, com link para revisar a integração.
                setErroIfood(resposta.mensagem || "Confira a integração com o iFood.")
                return
            }
            if (direcaoIfood === "IMPORTAR") {
                await recarregarCardapio()
            }
            alertStart(resposta?.mensagem || "Sincronização com o iFood concluída!", "success")
            setOpenSincronizarIfood(false)
            setDirecaoIfood(null)
        } catch (error) {
            console.error("Erro SincronizarIfood", error)
            setErroIfood(
                error?.response?.data?.mensagem ||
                    "Não foi possível concluir a sincronização. Confira a integração com o iFood."
            )
        } finally {
            setLoading(false)
        }
    }

    const handleClickOpenCategoria = () => setOpenCategoria(true)
    const handleCloseCategoria = () => setOpenCategoria(false)
    const handleCloseProduto = () => {
        setAltInsumo(false)
        setOpenproduto(false)
    }
    // Filtro de tipo e busca só atualizam estado de filtro; a lista exibida é derivada
    // (useMemo) a partir de `categorias` — sem sobrescrever o estado-fonte. Assim os
    // dois filtros compõem e edições/reordenação não são perdidas ao filtrar.
    const handleChangeCategoria = useCallback(e => {
        // Select multiple do MUI já entrega um array com os valores marcados.
        setTiposCategoria(e.target.value)
    }, [])

    const procurarProduto = useCallback(e => {
        setValorPesquisa(e.target.value)
    }, [])

    const categoriasFiltradas = useMemo(() => {
        let base = categorias ?? []
        if (tiposCategoria.length) {
            base = base.filter(cat => tiposCategoria.includes(cat.exibicaoCategoriaEnum))
        }
        if (valorPesquisa) {
            const termo = valorPesquisa.toLowerCase()
            // Mantém a categoria apenas se algum produto, ou alguma opção de produto
            // (passo de montagem ou adicional), casar com o termo buscado. O nome da
            // categoria não é usado como critério.
            base = base.filter(cat => categoriaCasaBusca(cat, termo))
        }
        return base
    }, [categorias, tiposCategoria, valorPesquisa])

    // Avisa ao recarregar/fechar a aba com edições inline não salvas.
    // O listener só existe enquanto esta tela está montada E há pendências.
    useEffect(() => {
        if (!temAlteracoesPendentes) return
        const handler = e => {
            e.preventDefault()
            e.returnValue = ""
        }
        window.addEventListener("beforeunload", handler)
        return () => window.removeEventListener("beforeunload", handler)
    }, [temAlteracoesPendentes])

    // Marca se houve reordenação de categoria para persistir só ao soltar.
    const reordenouCategoriaRef = useRef(false)

    const handleDragOver = useCallback(
        index => {
            if (draggingItem === null) return
            if (draggingItem === index) return
            // Reordenar só sem filtro ativo: com filtro, os índices da lista exibida
            // não correspondem aos de `categorias`.
            if (valorPesquisa || tiposCategoria.length) return
            const itens = categorias.filter((_, idx) => idx !== draggingItem)
            itens.splice(index, 0, categorias[draggingItem])
            setCategorias(itens.map((item, idx) => ({ ...item, ordemExib: idx })))
            setDraggingItem(index)
            reordenouCategoriaRef.current = true
        },
        [draggingItem, categorias, setCategorias, valorPesquisa, tiposCategoria]
    )

    const handleDragStartCategoria = useCallback(
        index => {
            // Sem reordenar com filtro/busca ativos (índices não batem com `categorias`).
            if (valorPesquisa || tiposCategoria.length) return
            reordenouCategoriaRef.current = false
            setDraggingItem(index)
        },
        [valorPesquisa, tiposCategoria]
    )

    // Ao soltar: encerra o arraste e, se a ordem mudou, persiste o cardápio
    // inteiro (ordem de categoria não é coberta pelo "Salvar Alterações").
    const handleDropCategoria = useCallback(() => {
        setDraggingItem(null)
        if (!reordenouCategoriaRef.current) return
        reordenouCategoriaRef.current = false
        persistirCategorias(categorias)
    }, [categorias, persistirCategorias])

    return (
        <>
            <Prompt
                when={!!temAlteracoesPendentes}
                message="Você tem alterações não salvas. Deseja sair mesmo assim?"
            />
            <DialogReordenar open={openReordenar} onClose={() => setOpenReordenar(false)} />
            <DialogCategorias
                open={openCategoria}
                cadastrar={cadastrar}
                modalCategoria={modalCategoria}
                estabelecimento={estabelecimento}
                categorias={categorias}
                handleCloseCategoria={handleCloseCategoria}
                handleSalvarCategoria={handleSalvarCategoria}
            />
            <DialogProdutos
                open={openProduto}
                modalProduto={modalProduto}
                cadastrar={cadastrar}
                handleCloseProduto={handleCloseProduto}
                handleSalvarProduto={handleSalvarProduto}
                categorias={categorias}
                categoriaAtual={categoriaAtual}
                handleCadastrarImagem={handleCadastrarImagem}
                estabelecimento={estabelecimento}
                insumos={insumos}
                insumoSelecionado={insumoSelecionado}
                insumosSelecionados={insumosSelecionados}
                fichaTecnica={fichaTecnica}
                quantidades={quantidades}
                handleAddInsumo={handleAddInsumo}
                handleDeleteInsumo={handleDeleteInsumo}
                salvarFt={salvarFt}
                setInsumoSelecionado={setInsumoSelecionado}
                setQuantidades={setQuantidades}
                setAltInsumo={setAltInsumo}
                buscarFT={buscarFT}
                produto={produto}
            />
            <DialogPassoDeMontagem
                open={openPassoDeMontagem}
                setOpenPassoDeMontagem={setOpenPassoDeMontagem}
                modalPasso={modalPasso}
                cadastrar={cadastrar}
                handleCadastrarGrupoDeOpcao={handleCadastrarGrupoDeOpcao}
                produtoAtual={produtoAtual}
            />
            <DialogDuplicarGrupoDeOpcao
                open={openDuplicarGrupoDeMontagem}
                handleToggleDuplicarGrupoDeMontagem={handleToggleDuplicarGrupoDeMontagem}
                categorias={categorias}
                handleDuplicarPassoDeMontagem={handleDuplicarPassoDeMontagem}
                idPasso={idPasso}
            />
            <div
                className={classes.container}
                style={{
                    width: mobile ? "100vw" : "calc(100vw - var(--drawer-width, 80px) - 17px)",
                    padding: mobile ? "0" : "0px 16px",
                    transition: "width 0.2s ease",
                }}
            >
                <div className={classes.cabecalho}>
                    <div className="container-opcoes-categorias">
                        <TextField
                            type="text"
                            variant="outlined"
                            label="Procurar produto/opção"
                            placeholder="Buscar por produto ou opção"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: "#4caf50" }} />
                                    </InputAdornment>
                                ),
                            }}
                            onChange={procurarProduto}
                            value={valorPesquisa}
                            className="campo-busca"
                            style={{ backgroundColor: "#fff", minWidth: "11rem" }}
                        />
                        <FormControl size="small" variant="outlined">
                            <InputLabel shrink id="tipo-categoria-label">
                                Tipo Categoria
                            </InputLabel>
                            <Select
                                labelId="tipo-categoria-label"
                                multiple
                                displayEmpty
                                value={tiposCategoria}
                                input={<OutlinedInput notched label="Tipo Categoria" />}
                                onChange={handleChangeCategoria}
                                renderValue={selecionados =>
                                    selecionados.length
                                        ? selecionados
                                              .map(valor => TIPOS_CATEGORIA[valor])
                                              .join(", ")
                                        : "Todos"
                                }
                                style={{ backgroundColor: "#fff" }}
                            >
                                {Object.entries(TIPOS_CATEGORIA).map(([valor, rotulo]) => (
                                    <MenuItem key={valor} value={valor}>
                                        <Checkbox
                                            checked={tiposCategoria.includes(valor)}
                                            style={{ color: "#4caf50" }}
                                        />
                                        <ListItemText primary={rotulo} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "0.5rem",
                            justifyContent: mobile ? "stretch" : "flex-end",
                            flex: mobile ? "1 1 100%" : "0 0 auto",
                            alignItems: "flex-start",
                        }}
                    >
                        <FloatingIAButton
                            inline
                            style={{ flex: mobile ? "1 1 100%" : "0 1 auto", minWidth: 0 }}
                        />
                        <Button
                            className={classes.botaoCadastrar}
                            startIcon={<AddIcon />}
                            onClick={() => {
                                handleClickOpenCategoria()
                                setCadastrar(true)
                                setModalCategoria(null)
                            }}
                            style={{ flex: mobile ? "1 1 100%" : "0 1 auto", minWidth: 0 }}
                        >
                            Cadastrar Categoria
                        </Button>
                        <Button
                            className={classes.botaoImprimir}
                            variant="outlined"
                            onClick={handleAbrirMenuAcoes}
                            endIcon={<ExpandMoreIcon />}
                            style={{ flex: mobile ? "1 1 100%" : "0 1 auto", minWidth: 0 }}
                        >
                            Mais ações
                        </Button>
                        <Button
                            onClick={handleSalvarCardapioInteiro}
                            className={classes.botaoSalvar}
                            disabled={loading}
                            style={{ flex: mobile ? "1 1 100%" : "0 1 auto", minWidth: 0 }}
                        >
                            Salvar Alterações
                        </Button>
                    </div>
                </div>
                <Menu
                    anchorEl={anchorMenuAcoes}
                    open={Boolean(anchorMenuAcoes)}
                    onClose={handleFecharMenuAcoes}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MenuItem
                        onClick={() => {
                            setOpenReordenar(true)
                            handleFecharMenuAcoes()
                        }}
                    >
                        <ListItemIcon>
                            <SwapVertIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Reordenar" />
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            setOpenConfirmacaoSalvar99(true)
                            handleFecharMenuAcoes()
                        }}
                    >
                        <ListItemIcon>
                            <img src={logo99} alt="" height={22} width={22} />
                        </ListItemIcon>
                        <ListItemText primary="Sincronizar 99Food" />
                    </MenuItem>
                    <MenuItem
                        className={ehClienteFiel ? undefined : classes.itemSemAcao}
                        disableRipple={!ehClienteFiel}
                        onClick={
                            ehClienteFiel
                                ? () => {
                                      handleAbrirSincronizarIfood()
                                      handleFecharMenuAcoes()
                                  }
                                : undefined
                        }
                    >
                        <ListItemIcon>
                            <img src={ifoodLogo} alt="" height={22} width={22} />
                        </ListItemIcon>
                        <ListItemText primary="Sincronizar iFood" />
                        <Chip label="em breve" size="small" className={classes.chipEmBreve} />
                    </MenuItem>
                    <MenuItem
                        component={Link}
                        to="/servicos/ferramenta/galeria"
                        onClick={handleFecharMenuAcoes}
                    >
                        <ListItemIcon>
                            <CollectionsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Galeria" />
                    </MenuItem>
                    <MenuItem
                        component={Link}
                        to="/servicos/ferramenta/edicao-cardapio/importar-exportar"
                        onClick={handleFecharMenuAcoes}
                    >
                        <ListItemIcon>
                            <InsertDriveFileIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Importar/Exportar" />
                    </MenuItem>
                    <MenuItem
                        component={Link}
                        to="/servicos/ferramenta/edicao-cardapio/historico"
                        onClick={handleFecharMenuAcoes}
                    >
                        <ListItemIcon>
                            <HistoryIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Histórico de cardápio" />
                    </MenuItem>
                </Menu>
                <Grid key={renderKey} className={classes.containerItens}>
                    <List fullWidth>
                        {categoriasFiltradas?.map((categoria, index) => (
                            <ListItem
                                className={classes.listItem}
                                key={categoria.id}
                                onDragOver={e => {
                                    e.preventDefault()
                                    handleDragOver(index)
                                }}
                                onDrop={handleDropCategoria}
                                onDragEnd={handleDropCategoria}
                            >
                                <Categorias
                                    index={index}
                                    categoria={categoria}
                                    termoBusca={valorPesquisa}
                                    arrastando={draggingItem === index}
                                    dragHandleProps={{
                                        draggable: true,
                                        onDragStart: () => handleDragStartCategoria(index),
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </div>
            <Dialog
                open={openConfirmacaoSalvar99}
                onClose={handleCloseConfirmacaoSalvar99}
                maxWidth="xs"
            >
                <DialogTitle>
                    Salvar Cardápio <img src={logo99} alt="Logo 99" height={36} width={36} />
                </DialogTitle>
                <DialogContent style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Typography>Atenção!</Typography>
                    <Typography>
                        Você está prestes a atualizar o cardápio da 99Food. Essa alteração irá
                        sobrescrever o cardápio cadastrado na 99 Food pelo cardápio da Cliente Fiel.
                    </Typography>
                    <Typography>Deseja continuar?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmacaoSalvar99}>Fechar</Button>
                    <Button color="primary" variant="contained" onClick={salvarCardapio99}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openSincronizarIfood}
                onClose={handleFecharSincronizarIfood}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Sincronizar cardápio com o iFood{" "}
                    <img
                        src={ifoodLogo}
                        alt="iFood"
                        height={32}
                        width={32}
                        style={{ verticalAlign: "middle" }}
                    />
                </DialogTitle>
                {erroIfood ? (
                    <DialogContent
                        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
                    >
                        <Typography style={{ fontWeight: 600, color: "#c62828" }}>
                            Não foi possível sincronizar com o iFood
                        </Typography>
                        <Typography>{erroIfood}</Typography>
                        <Typography variant="body2" color="textSecondary">
                            Revise a integração com o iFood e tente novamente.
                        </Typography>
                    </DialogContent>
                ) : !direcaoIfood ? (
                    <DialogContent
                        style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
                    >
                        <Typography>O que você deseja fazer?</Typography>
                        <Button
                            variant="outlined"
                            onClick={() => setDirecaoIfood("IMPORTAR")}
                            style={{
                                textTransform: "none",
                                justifyContent: "flex-start",
                                padding: "12px 16px",
                            }}
                        >
                            <div style={{ textAlign: "left" }}>
                                <Typography style={{ fontWeight: 600 }}>
                                    Baixar do iFood → Cardápio digital
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Importa o cardápio do iFood e sobrescreve o cardápio digital da
                                    Cliente Fiel.
                                </Typography>
                            </div>
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => setDirecaoIfood("PUBLICAR")}
                            style={{
                                textTransform: "none",
                                justifyContent: "flex-start",
                                padding: "12px 16px",
                            }}
                        >
                            <div style={{ textAlign: "left" }}>
                                <Typography style={{ fontWeight: 600 }}>
                                    Cardápio digital → iFood
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Usa o cardápio digital da Cliente Fiel para popular o cardápio do
                                    iFood.
                                </Typography>
                            </div>
                        </Button>
                    </DialogContent>
                ) : (
                    <DialogContent
                        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
                    >
                        <Typography style={{ fontWeight: 600, color: "#c62828" }}>
                            Atenção — ação irreversível!
                        </Typography>
                        <Typography>
                            {direcaoIfood === "IMPORTAR"
                                ? "O cardápio digital da Cliente Fiel será sobrescrito pelo cardápio do iFood."
                                : "O cardápio do iFood será sobrescrito pelo cardápio digital da Cliente Fiel."}
                        </Typography>
                        <Typography>
                            Essa operação não pode ser desfeita. Um backup do cardápio que será
                            sobrescrito é gerado automaticamente antes da substituição.
                        </Typography>
                        <Typography>Deseja continuar?</Typography>
                    </DialogContent>
                )}
                <DialogActions>
                    {erroIfood ? (
                        <>
                            <Button onClick={handleFecharSincronizarIfood}>Fechar</Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={handleRevisarIntegracaoIfood}
                            >
                                Revisar integração iFood
                            </Button>
                        </>
                    ) : !direcaoIfood ? (
                        <Button onClick={handleFecharSincronizarIfood} disabled={loading}>
                            Cancelar
                        </Button>
                    ) : (
                        <>
                            <Button onClick={() => setDirecaoIfood(null)} disabled={loading}>
                                Voltar
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={confirmarSincronizacaoIfood}
                                disabled={loading}
                            >
                                {loading ? "Sincronizando..." : "Confirmar"}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </>
    )
}
